import { FC } from 'react';
import classnames from 'classnames';

import { ProgressBarSingleProps } from '@hh.ru/magritte-ui-progress-bar/types';

import styles from './progress-bar.less';

const STYLE_TO_CSS = {
    accent: styles.progressStyleAccent,
    positive: styles.progressStylePositive,
    special: styles.progressStyleSpecial,
};

export const SingleProgressBar: FC<ProgressBarSingleProps> = ({
    max = 100,
    progress,
    style = 'accent',
    'data-qa': dataQA = 'progress',
    'aria-label': ariaLabel,
}) => {
    const width = (progress / max) * 100;
    return (
        <div
            className={classnames(styles.progress, STYLE_TO_CSS[style])}
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={max}
            aria-valuenow={progress}
            aria-label={ariaLabel}
            data-qa={dataQA}
        >
            <div className={styles.progressValue} data-qa="progress-value" style={{ width: `${width}%` }} />
        </div>
    );
};
